<template>
  <div class="b-tabs-wrap d-xl-flex">
    <VTabs
      class="b-tabs"
      v-model="tab"
      background-color="transparent"
      color="primary"
      slider-color="primary"
      :vertical="$vuetify.breakpoint.xlOnly"
      show-arrows
    >
      <VTab class="tab-name mr-4 mr-lg-6">
        {{ $t('plan') }}
      </VTab>
      <VTab class="tab-name mr-4 mr-lg-6">
        {{ $t('plans') }}
      </VTab>
      <VTab class="tab-name mr-6">
        {{ $t('info') }}
      </VTab>
      <!--      <VTab class="tab-name mr-6">-->
      <!--        {{ $t('transaction') }}-->
      <!--      </VTab>-->
      <VTab class="tab-name mr-6">
        {{ $t('payments') }}
      </VTab>
      <VTab class="tab-name mr-6">
        {{ $t('loyaltyProgram') }}
      </VTab>
      <VTab v-if="account.trialAvailable || account.trialEnabled" class="tab-name mr-6">
        {{ $t('trial') }}
      </VTab>
    </VTabs>
    <VTabsItems v-model="tab" class="flex-grow-1" touchless>
      <VTabItem class="account-card">
        <AppWithLoading :fetch="fetchData" v-slot:default="{localLoading}">
          <PaymentDashboard v-if="!localLoading" />
        </AppWithLoading>
      </VTabItem>
      <VTabItem class="account-card">
        <PaymentPlans />
      </VTabItem>
      <VTabItem class="account-card">
        <PaymentMethodsList />
      </VTabItem>
      <!--      <VTabItem>-->
      <!--        <Transactions />-->
      <!--      </VTabItem>-->
      <VTabItem>
        <BillingPayments />
      </VTabItem>
      <VTabItem class="account-card">
        <Referral />
      </VTabItem>
      <VTabItem>
        <PaymentTrial
          :plan-id="planId"
          :plan-title="planTitle"
          :period-id="periodId"
        />
      </VTabItem>
    </VTabsItems>
  </div>
</template>

<script>
import PaymentDashboard from '@/components/Payment/Dashboard/PaymentDashboard';
import useAccount from '@/compositions/accounting/useAccount';
import { computed, toRefs, watch } from '@vue/composition-api';
import PaymentPlans from '@/components/Payment/Plans/PaymentPlans';
import PaymentTrial from '@/components/Payment/Plans/PaymentTrial';
import BillingPayments from '@/components/Payment/Payments/BillingPayments';
import { paymentTabs } from '@/enums';
import PaymentMethodsList from '@/components/Payment/Methods/PaymentMethodsList';
import usePaymentMethods from '@/compositions/accounting/usePaymentMethods';
import AppWithLoading from '@/components/AppWithLoading';
import Referral from '@/components/Payment/Referral/Referral.vue';

export default {
  name: 'PaymentSettings',
  components: {
    AppWithLoading,
    PaymentMethodsList,
    PaymentPlans,
    PaymentTrial,
    PaymentDashboard,
    BillingPayments,
    Referral,
  },
  props: {
    type: {
      type: String,
      default: paymentTabs.PLAN,
    },
    planId: {
      type: Number,
      default: null,
    },
    planTitle: {
      type: String,
      default: null,
    },
    periodId: {
      type: Number,
      default: null,
    },
  },
  setup(props, { emit }) {
    const { type } = toRefs(props);
    const { fetch, account } = useAccount();
    const { fetchAll } = usePaymentMethods();

    async function fetchData() {
      await Promise.all([fetch(), fetchAll()]);
    }

    const tabList = [
      paymentTabs.PLAN,
      paymentTabs.PLANS,
      paymentTabs.INFO,
      paymentTabs.PAYMENTS,
      paymentTabs.LOYALTY,
      paymentTabs.TRIAL,
    ];

    const tab = computed((
      {
        get() {
          return tabList.indexOf(type.value) || 0;
        },
        set(index) {
          emit('input', tabList[index]);
        },
      }
    ));

    return {
      tab,
      fetchData,
      account,
    };
  },
};
</script>

<style lang="scss" scoped>
.tab-name {
  font-size: 1rem;
  letter-spacing: 0;
  line-height: 1.25;
}
.account-card {
  background: #FFFFFF;
  box-shadow: 0px 2px 0.5rem rgba(0, 0, 0, 0.16);
  border-radius: 0.625rem;
  @media screen and (max-width: 599px) {
    box-shadow: none;
  }
}
@media #{map-get($display-breakpoints, 'xl-only')} {
  .b-tabs-wrap {
    padding-top: 2.5rem;
  }
  .b-tabs {
    min-width: 15rem;
    max-width: 15rem;
    margin-right: 1.25rem;
  }
  .tab-name {
    justify-content: left;
    border-bottom: 1px solid rgba(196, 196, 196, 0.5);
  }
}

</style>

<i18n locale="en" lang="yaml">
  plan: Your plan
  plans: Plans and quotes
  history: Payment History
  info: Payment info
  trial: Trial period
  transaction: Transactions
  payments: Payments
  loyaltyProgram: Loyalty program
</i18n>

<i18n locale="ru" lang="yaml">
  plan: Ваш Тариф
  plans: Тарифы и квоты
  history: История пополнений
  info: Платежная информация
  trial: Пробный период
  transaction: Транзакции
  payments: Оплаты
  loyaltyProgram: Программа лояльности
</i18n>
